import { PropsWithChildren, ReactNode, useState } from 'react';

import { FilterDisplayCacheContext } from './context/filter-display-cache-context';
import { FilterValueMap, FilterValueMapCollection } from './models/filter-value-map';

export const FilterDisplayCache = (props: PropsWithChildren<unknown>) => {
    const [filterValueMap] = useState<FilterValueMapCollection>({});
    const [cache] = useState<{ [key: string]: unknown }>({});

    const registerFilterMap = (filterKey: string, map: FilterValueMap) => {
        filterValueMap[filterKey] = map;
    };

    const getDisplayValue = (filterKey: string, value: unknown) => {
        const getter = filterValueMap[filterKey];

        if (getter) {
            return getter(value);
        }

        // A filter whose component registered no label still has to read as
        // something: the value itself says more to a reader than the note that
        // a developer forgot one, which is what stood here and what the status
        // chip of every document list printed.
        return value as ReactNode;
    };

    return (
        <FilterDisplayCacheContext.Provider
            value={{
                registerFilterMap,
                getDisplayValue,
                getFromCache: key => cache[key],
                updateCache: (key, value) => (cache[key] = value),
            }}
        >
            {props.children}
        </FilterDisplayCacheContext.Provider>
    );
};
